/* eslint-disable */
/* This is generated by ts_routes-rails */

export type ScalarType = string | number | boolean;

function $buildOptions(options: any, names: string[]): string {
  if (options) {
    let anchor = "";
    const q = [] as string[];
    for (const key of Object.keys(options)) {
      if (names.indexOf(key) !== -1) {
        // the key is already consumed
        continue;
      }

      const value = options[key];

      if (key === "anchor") {
        anchor = `#${$encode(value)}`;
      } else {
        $buildQuery(q, key, value);
      }
    }
    return (q.length > 0 ? "?" + q.join("&") : "") + anchor;
  } else {
    return "";
  }
}

function $buildQuery(q: string[], key: string, value: any) {
  if ($isScalarType(value)) {
    q.push(`${$encode(key)}=${$encode(value)}`);
  } else if (Array.isArray(value)) {
    for (const v of value) {
      $buildQuery(q, `${key}[]`, v);
    }
  } else if (value != null) {
    // i.e. non-null, non-scalar, non-array type
    for (const k of Object.keys(value)) {
      $buildQuery(q, `${key}[${k}]`, value[k]);
    }
  }
}

function $encode(value: any): string {
  return encodeURIComponent(value);
}

function $isScalarType(value: any): value is ScalarType {
  return (
    typeof value === "string" ||
    typeof value === "number" ||
    typeof value === "boolean"
  );
}

function $isPresent(value: any): boolean {
  return value != null && ("" + value).length > 0;
}

function $hasPresentOwnProperty(options: any, key: string): boolean {
  return options && options.hasOwnProperty(key) && $isPresent(options[key]);
}

/** /rails/info/properties(.:format) */
export function rails_info_properties_path(options?: object): string {
  return "/" + "rails" + "/" + "info" + "/" + "properties" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /rails/info/routes(.:format) */
export function rails_info_routes_path(options?: object): string {
  return "/" + "rails" + "/" + "info" + "/" + "routes" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /rails/info/notes(.:format) */
export function rails_info_notes_path(options?: object): string {
  return "/" + "rails" + "/" + "info" + "/" + "notes" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /rails/info(.:format) */
export function rails_info_path(options?: object): string {
  return "/" + "rails" + "/" + "info" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /users/sign_in(.:format) */
export function new_user_session_path(options?: object): string {
  return "/" + "users" + "/" + "sign_in" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /users/sign_in(.:format) */
export function user_session_path(options?: object): string {
  return "/" + "users" + "/" + "sign_in" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /users/sign_out(.:format) */
export function destroy_user_session_path(options?: object): string {
  return "/" + "users" + "/" + "sign_out" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /users/auth/ndid(.:format) */
export function user_ndid_omniauth_authorize_path(options?: object): string {
  return "/" + "users" + "/" + "auth" + "/" + "ndid" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /users/auth/ndid/callback(.:format) */
export function user_ndid_omniauth_callback_path(options?: object): string {
  return "/" + "users" + "/" + "auth" + "/" + "ndid" + "/" + "callback" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /users/auth/google_oauth2(.:format) */
export function user_google_oauth2_omniauth_authorize_path(options?: object): string {
  return "/" + "users" + "/" + "auth" + "/" + "google_oauth2" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /users/auth/google_oauth2/callback(.:format) */
export function user_google_oauth2_omniauth_callback_path(options?: object): string {
  return "/" + "users" + "/" + "auth" + "/" + "google_oauth2" + "/" + "callback" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/sidekiq */
export function sidekiq_path(options?: object): string {
  return "/" + "admin" + "/" + "sidekiq" + $buildOptions(options, []);
}

/** /admin/aws_sg_manager */
export function aws_sg_manager_path(options?: object): string {
  return "/" + "admin" + "/" + "aws_sg_manager" + $buildOptions(options, []);
}

/** /admin/aws_sg_manager/security_groups(.:format) */
export function aws_sg_manager_security_groups_path(options?: object): string {
  return "/" + "admin" + "/" + "aws_sg_manager" + "/" + "security_groups" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/aws_sg_manager/security_groups/:id(.:format) */
export function aws_sg_manager_security_group_path(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "aws_sg_manager" + "/" + "security_groups" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/aws_sg_manager/security_groups/:id(.:format) */
export function aws_sg_manager_update_security_groups_path(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "aws_sg_manager" + "/" + "security_groups" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/aws_sg_manager/security_groups/:id/import(.:format) */
export function aws_sg_manager_import_security_groups_path(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "aws_sg_manager" + "/" + "security_groups" + "/" + id + "/" + "import" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/aws_sg_manager/ */
export function aws_sg_manager_root_path(options?: object): string {
  return "/" + "admin" + "/" + "aws_sg_manager" + "/" + $buildOptions(options, []);
}

/** /admin/s3_visualizer */
export function s3_visualizer_path(options?: object): string {
  return "/" + "admin" + "/" + "s3_visualizer" + $buildOptions(options, []);
}

/** /admin/s3_visualizer/groups/:group_id/buckets(.:format) */
export function s3_visualizer_group_buckets_path(group_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "s3_visualizer" + "/" + "groups" + "/" + group_id + "/" + "buckets" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["group_id","format"]);
}

/** /admin/s3_visualizer/groups/:group_id/buckets/:id(.:format) */
export function s3_visualizer_group_bucket_path(group_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "s3_visualizer" + "/" + "groups" + "/" + group_id + "/" + "buckets" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["group_id","id","format"]);
}

/** /admin/s3_visualizer/groups(.:format) */
export function s3_visualizer_groups_path(options?: object): string {
  return "/" + "admin" + "/" + "s3_visualizer" + "/" + "groups" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/s3_visualizer/ */
export function s3_visualizer_root_path(options?: object): string {
  return "/" + "admin" + "/" + "s3_visualizer" + "/" + $buildOptions(options, []);
}

/** / */
export function root_path(options?: object): string {
  return "/" + $buildOptions(options, []);
}

/** /deploy_stats(.:format) */
export function deploy_stats_path(options?: object): string {
  return "/" + "deploy_stats" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /gdpr(.:format) */
export function gdpr_path(options?: object): string {
  return "/" + "gdpr" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /gdpr_enqueue(.:format) */
export function gdpr_enqueue_path(options?: object): string {
  return "/" + "gdpr_enqueue" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /gdpr_retry(.:format) */
export function gdpr_retry_path(options?: object): string {
  return "/" + "gdpr_retry" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /titles/:title_uuid/raw_posts(.:format) */
export function title_raw_posts_path(title_uuid: ScalarType, options?: object): string {
  return "/" + "titles" + "/" + title_uuid + "/" + "raw_posts" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","format"]);
}

/** /raw_posts/:id(.:format) */
export function raw_post_path(id: ScalarType, options?: object): string {
  return "/" + "raw_posts" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /release_tags/:id/deploy(.:format) */
export function deploy_release_tag_path(id: ScalarType, options?: object): string {
  return "/" + "release_tags" + "/" + id + "/" + "deploy" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /titles/:title_uuid/release_tags(.:format) */
export function title_release_tags_path(title_uuid: ScalarType, options?: object): string {
  return "/" + "titles" + "/" + title_uuid + "/" + "release_tags" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","format"]);
}

/** /titles/:title_uuid/release_tags/new(.:format) */
export function new_title_release_tag_path(title_uuid: ScalarType, options?: object): string {
  return "/" + "titles" + "/" + title_uuid + "/" + "release_tags" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","format"]);
}

/** /release_tags/:id/edit(.:format) */
export function edit_release_tag_path(id: ScalarType, options?: object): string {
  return "/" + "release_tags" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /release_tags/:id(.:format) */
export function release_tag_path(id: ScalarType, options?: object): string {
  return "/" + "release_tags" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /titles/:title_uuid/webhook/test(.:format) */
export function test_title_webhook_path(title_uuid: ScalarType, options?: object): string {
  return "/" + "titles" + "/" + title_uuid + "/" + "webhook" + "/" + "test" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","format"]);
}

/** /titles/:title_uuid/webhook/edit(.:format) */
export function edit_title_webhook_path(title_uuid: ScalarType, options?: object): string {
  return "/" + "titles" + "/" + title_uuid + "/" + "webhook" + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","format"]);
}

/** /titles/:title_uuid/webhook(.:format) */
export function title_webhook_path(title_uuid: ScalarType, options?: object): string {
  return "/" + "titles" + "/" + title_uuid + "/" + "webhook" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","format"]);
}

/** /titles/:title_uuid/bigquery/:env(.:format) */
export function title_bigquery_path(title_uuid: ScalarType, env: ScalarType, options?: object): string {
  return "/" + "titles" + "/" + title_uuid + "/" + "bigquery" + "/" + env + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","env","format"]);
}

/** /titles/:title_uuid/bigquery/:env/unverify(.:format) */
export function title_bigquery_unverify_path(title_uuid: ScalarType, env: ScalarType, options?: object): string {
  return "/" + "titles" + "/" + title_uuid + "/" + "bigquery" + "/" + env + "/" + "unverify" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","env","format"]);
}

/** /titles/:title_uuid/bigquery/:env/query(.:format) */
export function title_bigquery_query_form_path(title_uuid: ScalarType, env: ScalarType, options?: object): string {
  return "/" + "titles" + "/" + title_uuid + "/" + "bigquery" + "/" + env + "/" + "query" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","env","format"]);
}

/** /titles/:title_uuid/bigquery/:env/tables(.:format) */
export function title_bigquery_tables_path(title_uuid: ScalarType, env: ScalarType, options?: object): string {
  return "/" + "titles" + "/" + title_uuid + "/" + "bigquery" + "/" + env + "/" + "tables" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","env","format"]);
}

/** /titles/:title_uuid/bigquery/:env/history(.:format) */
export function title_bigquery_history_path(title_uuid: ScalarType, env: ScalarType, options?: object): string {
  return "/" + "titles" + "/" + title_uuid + "/" + "bigquery" + "/" + env + "/" + "history" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","env","format"]);
}

/** /titles/:title_uuid/s3(.:format) */
export function title_s3_path(title_uuid: ScalarType, options?: object): string {
  return "/" + "titles" + "/" + title_uuid + "/" + "s3" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","format"]);
}

/** /titles/:title_uuid/access_keys/:id/attach_l3_policy(.:format) */
export function attach_l3_policy_title_access_key_path(title_uuid: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "titles" + "/" + title_uuid + "/" + "access_keys" + "/" + id + "/" + "attach_l3_policy" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","id","format"]);
}

/** /titles/:title_uuid/access_keys/:id/detach_l3_policy(.:format) */
export function detach_l3_policy_title_access_key_path(title_uuid: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "titles" + "/" + title_uuid + "/" + "access_keys" + "/" + id + "/" + "detach_l3_policy" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","id","format"]);
}

/** /titles/:title_uuid/access_keys(.:format) */
export function title_access_keys_path(title_uuid: ScalarType, options?: object): string {
  return "/" + "titles" + "/" + title_uuid + "/" + "access_keys" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","format"]);
}

/** /titles/:title_uuid/access_keys/:id(.:format) */
export function title_access_key_path(title_uuid: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "titles" + "/" + title_uuid + "/" + "access_keys" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","id","format"]);
}

/** /titles/:title_uuid/users(.:format) */
export function title_users_path(title_uuid: ScalarType, options?: object): string {
  return "/" + "titles" + "/" + title_uuid + "/" + "users" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","format"]);
}

/** /titles/:title_uuid/jobs(.:format) */
export function title_jobs_path(title_uuid: ScalarType, options?: object): string {
  return "/" + "titles" + "/" + title_uuid + "/" + "jobs" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","format"]);
}

/** /titles/:title_uuid/jobs/:id(.:format) */
export function title_job_path(title_uuid: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "titles" + "/" + title_uuid + "/" + "jobs" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","id","format"]);
}

/** /titles/:title_uuid/external_service_accounts(.:format) */
export function title_external_service_accounts_path(title_uuid: ScalarType, options?: object): string {
  return "/" + "titles" + "/" + title_uuid + "/" + "external_service_accounts" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","format"]);
}

/** /titles/:title_uuid/external_service_accounts/new(.:format) */
export function new_title_external_service_account_path(title_uuid: ScalarType, options?: object): string {
  return "/" + "titles" + "/" + title_uuid + "/" + "external_service_accounts" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","format"]);
}

/** /external_service_accounts/:id/edit(.:format) */
export function edit_external_service_account_path(id: ScalarType, options?: object): string {
  return "/" + "external_service_accounts" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /external_service_accounts/:id(.:format) */
export function external_service_account_path(id: ScalarType, options?: object): string {
  return "/" + "external_service_accounts" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /titles/:title_uuid/bigquery_authorized_views(.:format) */
export function title_bigquery_authorized_views_path(title_uuid: ScalarType, options?: object): string {
  return "/" + "titles" + "/" + title_uuid + "/" + "bigquery_authorized_views" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","format"]);
}

/** /titles/:title_uuid/bigquery_authorized_views/new(.:format) */
export function new_title_bigquery_authorized_view_path(title_uuid: ScalarType, options?: object): string {
  return "/" + "titles" + "/" + title_uuid + "/" + "bigquery_authorized_views" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","format"]);
}

/** /bigquery_authorized_views/:id/edit(.:format) */
export function edit_bigquery_authorized_view_path(id: ScalarType, options?: object): string {
  return "/" + "bigquery_authorized_views" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /bigquery_authorized_views/:id(.:format) */
export function bigquery_authorized_view_path(id: ScalarType, options?: object): string {
  return "/" + "bigquery_authorized_views" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /titles/:title_uuid/event_masters/copy(.:format) */
export function copy_title_event_masters_path(title_uuid: ScalarType, options?: object): string {
  return "/" + "titles" + "/" + title_uuid + "/" + "event_masters" + "/" + "copy" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","format"]);
}

/** /titles/:title_uuid/event_masters/copy/exec(.:format) */
export function copy_exec_title_event_masters_path(title_uuid: ScalarType, options?: object): string {
  return "/" + "titles" + "/" + title_uuid + "/" + "event_masters" + "/" + "copy" + "/" + "exec" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","format"]);
}

/** /event_masters/:id/define(.:format) */
export function define_event_master_path(id: ScalarType, options?: object): string {
  return "/" + "event_masters" + "/" + id + "/" + "define" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /event_masters/:id/versions(.:format) */
export function versions_event_master_path(id: ScalarType, options?: object): string {
  return "/" + "event_masters" + "/" + id + "/" + "versions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /event_masters/:id/test_send/:env(.:format) */
export function test_send_event_master_path(id: ScalarType, env: ScalarType, options?: object): string {
  return "/" + "event_masters" + "/" + id + "/" + "test_send" + "/" + env + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","env","format"]);
}

/** /event_masters/:event_master_id/jobs(.:format) */
export function event_master_jobs_path(event_master_id: ScalarType, options?: object): string {
  return "/" + "event_masters" + "/" + event_master_id + "/" + "jobs" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["event_master_id","format"]);
}

/** /titles/:title_uuid/event_masters(.:format) */
export function title_event_masters_path(title_uuid: ScalarType, options?: object): string {
  return "/" + "titles" + "/" + title_uuid + "/" + "event_masters" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","format"]);
}

/** /titles/:title_uuid/event_masters/new(.:format) */
export function new_title_event_master_path(title_uuid: ScalarType, options?: object): string {
  return "/" + "titles" + "/" + title_uuid + "/" + "event_masters" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","format"]);
}

/** /event_masters/:id/edit(.:format) */
export function edit_event_master_path(id: ScalarType, options?: object): string {
  return "/" + "event_masters" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /event_masters/:id(.:format) */
export function event_master_path(id: ScalarType, options?: object): string {
  return "/" + "event_masters" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /titles(.:format) */
export function titles_path(options?: object): string {
  return "/" + "titles" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /titles/new(.:format) */
export function new_title_path(options?: object): string {
  return "/" + "titles" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /titles/:uuid/edit(.:format) */
export function edit_title_path(uuid: ScalarType, options?: object): string {
  return "/" + "titles" + "/" + uuid + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["uuid","format"]);
}

/** /titles/:uuid(.:format) */
export function title_path(uuid: ScalarType, options?: object): string {
  return "/" + "titles" + "/" + uuid + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["uuid","format"]);
}

/** /s3_buckets(.:format) */
export function s3_buckets_path(options?: object): string {
  return "/" + "s3_buckets" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /s3_buckets/:bucket_name/s3_objects(.:format) */
export function s3_objects_path(bucket_name: ScalarType, options?: object): string {
  return "/" + "s3_buckets" + "/" + bucket_name + "/" + "s3_objects" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["bucket_name","format"]);
}

/** /s3_buckets/:bucket_name/s3_objects/*key */
export function s3_object_path(bucket_name: ScalarType, key: ScalarType[], options?: object): string {
  return "/" + "s3_buckets" + "/" + bucket_name + "/" + "s3_objects" + "/" + key.map((part) => $encode(part)).join("/") + $buildOptions(options, ["bucket_name","key"]);
}

/** /jobs/bigquery_query_jobs_stats(.:format) */
export function bigquery_query_jobs_stats_jobs_path(options?: object): string {
  return "/" + "jobs" + "/" + "bigquery_query_jobs_stats" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /jobs(.:format) */
export function jobs_path(options?: object): string {
  return "/" + "jobs" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /jobs/:id(.:format) */
export function job_path(id: ScalarType, options?: object): string {
  return "/" + "jobs" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/status(.:format) */
export function api_status_path(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "status" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/titles/:title_uuid/raw_posts(.:format) */
export function api_title_raw_posts_path(title_uuid: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "titles" + "/" + title_uuid + "/" + "raw_posts" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","format"]);
}

/** /api/v1/raw_posts/:id(.:format) */
export function api_raw_post_path(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "raw_posts" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/event_masters/:event_master_id/versions/:version_id/note(.:format) */
export function api_event_master_update_version_note_path(event_master_id: ScalarType, version_id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "event_masters" + "/" + event_master_id + "/" + "versions" + "/" + version_id + "/" + "note" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["event_master_id","version_id","format"]);
}

/** /api/v1/event_masters/:event_master_id/suggestion(.:format) */
export function api_event_master_suggestion_path(event_master_id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "event_masters" + "/" + event_master_id + "/" + "suggestion" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["event_master_id","format"]);
}

/** /api/v1/event_masters/:event_master_id/ddl/:env(.:format) */
export function api_event_master_ddl_path(event_master_id: ScalarType, env: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "event_masters" + "/" + event_master_id + "/" + "ddl" + "/" + env + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["event_master_id","env","format"]);
}

/** /api/v1/event_masters/:event_master_id/jsonpath/:env(.:format) */
export function api_event_master_jsonpath_path(event_master_id: ScalarType, env: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "event_masters" + "/" + event_master_id + "/" + "jsonpath" + "/" + env + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["event_master_id","env","format"]);
}

/** /api/v1/event_masters/:event_master_id/deploy/:env(.:format) */
export function api_event_master_deploy_path(event_master_id: ScalarType, env: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "event_masters" + "/" + event_master_id + "/" + "deploy" + "/" + env + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["event_master_id","env","format"]);
}

/** /api/v1/event_masters/:event_master_id/table_status/:env(.:format) */
export function api_event_master_table_status_path(event_master_id: ScalarType, env: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "event_masters" + "/" + event_master_id + "/" + "table_status" + "/" + env + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["event_master_id","env","format"]);
}

/** /api/v1/event_masters/:event_master_id/last_deploy_status(.:format) */
export function api_event_master_last_deploy_status_path(event_master_id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "event_masters" + "/" + event_master_id + "/" + "last_deploy_status" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["event_master_id","format"]);
}

/** /api/v1/event_masters/:event_master_id/last_copy_status(.:format) */
export function api_event_master_last_copy_status_path(event_master_id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "event_masters" + "/" + event_master_id + "/" + "last_copy_status" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["event_master_id","format"]);
}

/** /api/v1/event_masters/:event_master_id/s3/:env(.:format) */
export function api_event_master_s3_stats_path(event_master_id: ScalarType, env: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "event_masters" + "/" + event_master_id + "/" + "s3" + "/" + env + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["event_master_id","env","format"]);
}

/** /api/v1/event_masters/:event_master_id/copy_from_s3/:env(.:format) */
export function api_event_master_copy_from_s3_path(event_master_id: ScalarType, env: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "event_masters" + "/" + event_master_id + "/" + "copy_from_s3" + "/" + env + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["event_master_id","env","format"]);
}

/** /api/v1/event_masters/:event_master_id/bigquery_load_statuses/:env(.:format) */
export function api_event_master_load_status_path(event_master_id: ScalarType, env: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "event_masters" + "/" + event_master_id + "/" + "bigquery_load_statuses" + "/" + env + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["event_master_id","env","format"]);
}

/** /api/v1/event_masters/:event_master_id/s3/:env/delete(.:format) */
export function api_event_master_s3_delete_path(event_master_id: ScalarType, env: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "event_masters" + "/" + event_master_id + "/" + "s3" + "/" + env + "/" + "delete" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["event_master_id","env","format"]);
}

/** /api/v1/event_masters/:id(.:format) */
export function api_event_master_path(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "event_masters" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/titles/:title_uuid/bigquery/:env/tables(.:format) */
export function api_bigquery_tables_path(title_uuid: ScalarType, env: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "titles" + "/" + title_uuid + "/" + "bigquery" + "/" + env + "/" + "tables" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","env","format"]);
}

/** /api/v1/titles/:title_uuid/bigquery/:env/tables/:table_name(.:format) */
export function api_bigquery_table_ddl_path(title_uuid: ScalarType, env: ScalarType, table_name: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "titles" + "/" + title_uuid + "/" + "bigquery" + "/" + env + "/" + "tables" + "/" + table_name + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","env","table_name","format"]);
}

/** /api/v1/titles/:title_uuid/bigquery/:env/tables/:table_name(.:format) */
export function api_delete_bigquery_table_path(title_uuid: ScalarType, env: ScalarType, table_name: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "titles" + "/" + title_uuid + "/" + "bigquery" + "/" + env + "/" + "tables" + "/" + table_name + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","env","table_name","format"]);
}

/** /api/v1/titles/:title_uuid/bigquery/:env/queries(.:format) */
export function api_bigquery_queries_path(title_uuid: ScalarType, env: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "titles" + "/" + title_uuid + "/" + "bigquery" + "/" + env + "/" + "queries" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","env","format"]);
}

/** /api/v1/titles/:title_uuid/bigquery/:env/queries/:query_id(.:format) */
export function api_show_bigquery_query_path(title_uuid: ScalarType, env: ScalarType, query_id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "titles" + "/" + title_uuid + "/" + "bigquery" + "/" + env + "/" + "queries" + "/" + query_id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","env","query_id","format"]);
}

/** /api/v1/titles/:title_uuid/bigquery/:env/queries/:query_id/stop(.:format) */
export function api_stop_bigquery_query_path(title_uuid: ScalarType, env: ScalarType, query_id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "titles" + "/" + title_uuid + "/" + "bigquery" + "/" + env + "/" + "queries" + "/" + query_id + "/" + "stop" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","env","query_id","format"]);
}

/** /api/v1/titles/:title_uuid/bigquery/:env/queries/:query_id/export(.:format) */
export function api_export_bigquery_query_path(title_uuid: ScalarType, env: ScalarType, query_id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "titles" + "/" + title_uuid + "/" + "bigquery" + "/" + env + "/" + "queries" + "/" + query_id + "/" + "export" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","env","query_id","format"]);
}

/** /api/v1/titles/:title_uuid/bigquery/:env/queries(.:format) */
export function api_create_bigquery_query_path(title_uuid: ScalarType, env: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "titles" + "/" + title_uuid + "/" + "bigquery" + "/" + env + "/" + "queries" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","env","format"]);
}

/** /api/v1/titles/:title_uuid/bigquery/:env/queries/dryrun(.:format) */
export function api_dryrun_bigquery_query_path(title_uuid: ScalarType, env: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "titles" + "/" + title_uuid + "/" + "bigquery" + "/" + env + "/" + "queries" + "/" + "dryrun" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","env","format"]);
}

/** /api/v1/titles/:title_uuid/bigquery/:env/queries/complete(.:format) */
export function api_complete_bigquery_query_path(title_uuid: ScalarType, env: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "titles" + "/" + title_uuid + "/" + "bigquery" + "/" + env + "/" + "queries" + "/" + "complete" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","env","format"]);
}

/** /api/v1/titles/:title_uuid/bigquery/:env/queries/fix(.:format) */
export function api_fix_bigquery_query_path(title_uuid: ScalarType, env: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "titles" + "/" + title_uuid + "/" + "bigquery" + "/" + env + "/" + "queries" + "/" + "fix" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","env","format"]);
}

/** /api/v1/titles/:title_uuid/bigquery/:env/queries/edit(.:format) */
export function api_edit_bigquery_query_path(title_uuid: ScalarType, env: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "titles" + "/" + title_uuid + "/" + "bigquery" + "/" + env + "/" + "queries" + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","env","format"]);
}

/** /api/v1/titles/:title_uuid/bigquery/:env/queries/nes(.:format) */
export function api_nes_bigquery_query_path(title_uuid: ScalarType, env: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "titles" + "/" + title_uuid + "/" + "bigquery" + "/" + env + "/" + "queries" + "/" + "nes" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","env","format"]);
}

/** /api/v1/titles/:title_uuid/bigquery/:env/queries/chat(.:format) */
export function api_chat_bigquery_query_path(title_uuid: ScalarType, env: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "titles" + "/" + title_uuid + "/" + "bigquery" + "/" + env + "/" + "queries" + "/" + "chat" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","env","format"]);
}

/** /api/v1/titles/:title_uuid/bigquery/:env/queries/chat/histories(.:format) */
export function api_bigquery_query_chat_histories_path(title_uuid: ScalarType, env: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "titles" + "/" + title_uuid + "/" + "bigquery" + "/" + env + "/" + "queries" + "/" + "chat" + "/" + "histories" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","env","format"]);
}

/** /api/v1/titles/:title_uuid/bigquery/:env/queries/chat/histories/:session_key(.:format) */
export function api_bigquery_query_chat_history_path(title_uuid: ScalarType, env: ScalarType, session_key: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "titles" + "/" + title_uuid + "/" + "bigquery" + "/" + env + "/" + "queries" + "/" + "chat" + "/" + "histories" + "/" + session_key + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","env","session_key","format"]);
}

/** /api/v1/titles/:title_uuid/bigquery/:env/queries/chat/preferences(.:format) */
export function api_bigquery_chat_preferences_path(title_uuid: ScalarType, env: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "titles" + "/" + title_uuid + "/" + "bigquery" + "/" + env + "/" + "queries" + "/" + "chat" + "/" + "preferences" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","env","format"]);
}

/** /api/v1/titles/:title_uuid/bigquery/:env/queries/chat/preferences(.:format) */
export function api_update_bigquery_chat_preferences_path(title_uuid: ScalarType, env: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "titles" + "/" + title_uuid + "/" + "bigquery" + "/" + env + "/" + "queries" + "/" + "chat" + "/" + "preferences" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","env","format"]);
}

/** /api/v1/titles/:title_uuid/bigquery/:env/saved_queries(.:format) */
export function api_bigquery_saved_queries_path(title_uuid: ScalarType, env: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "titles" + "/" + title_uuid + "/" + "bigquery" + "/" + env + "/" + "saved_queries" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","env","format"]);
}

/** /api/v1/titles/:title_uuid/bigquery/:env/saved_queries(.:format) */
export function api_create_bigquery_saved_query_path(title_uuid: ScalarType, env: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "titles" + "/" + title_uuid + "/" + "bigquery" + "/" + env + "/" + "saved_queries" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","env","format"]);
}

/** /api/v1/titles/:title_uuid/bigquery/:env/saved_queries/:saved_query_id(.:format) */
export function api_update_bigquery_saved_query_path(title_uuid: ScalarType, env: ScalarType, saved_query_id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "titles" + "/" + title_uuid + "/" + "bigquery" + "/" + env + "/" + "saved_queries" + "/" + saved_query_id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","env","saved_query_id","format"]);
}

/** /api/v1/titles/:title_uuid/bigquery/:env/saved_queries/:saved_query_id(.:format) */
export function api_delete_bigquery_saved_query_path(title_uuid: ScalarType, env: ScalarType, saved_query_id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "titles" + "/" + title_uuid + "/" + "bigquery" + "/" + env + "/" + "saved_queries" + "/" + saved_query_id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","env","saved_query_id","format"]);
}

/** /api/v1/titles/:title_uuid/bigquery/:env/shared_queries(.:format) */
export function api_bigquery_shared_queries_path(title_uuid: ScalarType, env: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "titles" + "/" + title_uuid + "/" + "bigquery" + "/" + env + "/" + "shared_queries" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","env","format"]);
}

/** /api/v1/titles/:title_uuid/bigquery/:env/shared_queries(.:format) */
export function api_create_bigquery_shared_query_path(title_uuid: ScalarType, env: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "titles" + "/" + title_uuid + "/" + "bigquery" + "/" + env + "/" + "shared_queries" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","env","format"]);
}

/** /api/v1/titles/:title_uuid/bigquery/:env/shared_queries/:shared_query_id(.:format) */
export function api_update_bigquery_shared_query_path(title_uuid: ScalarType, env: ScalarType, shared_query_id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "titles" + "/" + title_uuid + "/" + "bigquery" + "/" + env + "/" + "shared_queries" + "/" + shared_query_id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","env","shared_query_id","format"]);
}

/** /api/v1/titles/:title_uuid/bigquery/:env/shared_queries/:shared_query_id(.:format) */
export function api_delete_bigquery_shared_query_path(title_uuid: ScalarType, env: ScalarType, shared_query_id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "titles" + "/" + title_uuid + "/" + "bigquery" + "/" + env + "/" + "shared_queries" + "/" + shared_query_id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","env","shared_query_id","format"]);
}

/** /api/v1/users/titles/:title_uuid/registered(.:format) */
export function api_title_users_registered_path(title_uuid: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "users" + "/" + "titles" + "/" + title_uuid + "/" + "registered" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","format"]);
}

/** /api/v1/users/titles/:title_uuid/unregistered(.:format) */
export function api_title_users_unregistered_path(title_uuid: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "users" + "/" + "titles" + "/" + title_uuid + "/" + "unregistered" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","format"]);
}

/** /api/v1/users/titles/:title_uuid/roles(.:format) */
export function api_title_create_user_roles_path(title_uuid: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "users" + "/" + "titles" + "/" + title_uuid + "/" + "roles" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","format"]);
}

/** /api/v1/users/titles/:title_uuid/roles(.:format) */
export function api_title_update_user_roles_path(title_uuid: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "users" + "/" + "titles" + "/" + title_uuid + "/" + "roles" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","format"]);
}

/** /api/v1/users/titles/:title_uuid/roles(.:format) */
export function api_title_delete_user_roles_path(title_uuid: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "users" + "/" + "titles" + "/" + title_uuid + "/" + "roles" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["title_uuid","format"]);
}

/** /api/v1/titles(.:format) */
export function api_titles_path(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "titles" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/titles/new(.:format) */
export function new_api_title_path(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "titles" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/titles/:uuid/edit(.:format) */
export function edit_api_title_path(uuid: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "titles" + "/" + uuid + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["uuid","format"]);
}

/** /api/v1/titles/:uuid(.:format) */
export function api_title_path(uuid: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "titles" + "/" + uuid + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["uuid","format"]);
}

/** /recede_historical_location(.:format) */
export function turbo_recede_historical_location_path(options?: object): string {
  return "/" + "recede_historical_location" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /resume_historical_location(.:format) */
export function turbo_resume_historical_location_path(options?: object): string {
  return "/" + "resume_historical_location" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /refresh_historical_location(.:format) */
export function turbo_refresh_historical_location_path(options?: object): string {
  return "/" + "refresh_historical_location" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}
